import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { STATIC_VIDEOS_URLS } from 'modules/core/constants';

import { LearningWrapper } from '../common/LearningWrapper/LearningWrapper';
import { CardForm, TitleH1, Video } from '../styles';
import { LEARNING_PATHS } from '../Learning.const';
import { MiniCard } from '../common/MiniCard/MiniCard';

export const LearningAffordability: React.FC = () => {
  const { t } = useTranslation();

  return (
    <LearningWrapper prevPageLink={LEARNING_PATHS.creditHistory} nextPageLink={LEARNING_PATHS.loanToValue}>
      <TitleH1>{t('components.learningLink.affordability.title')}</TitleH1>
      {t('components.learningLink.affordability.description')}
      <CardForm>
        <MiniCard
          title={t('components.learningLink.affordability.miniCard.title')}
          price={t('components.learningLink.affordability.miniCard.price')}
          priceDescription={t('components.learningLink.affordability.miniCard.priceDescription')}
        />
        <Video autoPlay muted playsInline>
          <source src={STATIC_VIDEOS_URLS.affordabilitySlider} type="video/mp4" />
        </Video>
        <Trans defaults={t('components.learningLink.affordability.cardDescription')} components={[<strong />]} />
      </CardForm>
    </LearningWrapper>
  );
};
